import {Component, inject, Input} from '@angular/core';
import {StateService} from "@uirouter/core";
import * as _ from 'lodash';

import {
    MenuService,
    ParametersService,
    SubtitlesService, ViewsService,
    ZonesService
} from "../../core";
import {OpenThermZoneTile, ZoneTileViewData} from "../../models";

@Component({
    selector: 'open-therm',
    templateUrl: './opentherm.component.html',
    styleUrls: ['./opentherm.component.scss']
})
export class OpenThermComponent {
    @Input() tile!: OpenThermZoneTile;

    private menu = inject(MenuService);
    private parameters = inject(ParametersService);
    private $state = inject(StateService);
    private subtitlesService = inject(SubtitlesService);
    public views = inject(ViewsService);
    public zones = inject(ZonesService);

    protected labels = {
        title:                this.subtitlesService.setSubtitle(4633),
        currentTemp:          this.subtitlesService.setSubtitle(127),
        currentTempDHW:       this.subtitlesService.setSubtitle(128),
        modulationPercentage: this.subtitlesService.setSubtitle(428),
        communication:        this.subtitlesService.setSubtitle(331),
        heatingCurve:         this.subtitlesService.setSubtitle(342),
        activeHeating:        this.subtitlesService.setSubtitle(2585),
        activeDHW:            this.subtitlesService.setSubtitle(2586),
        alarmCode:            this.subtitlesService.setSubtitle(661),
        communicationAlert:   this.subtitlesService.setSubtitle(1808),
    };

    get isStatusAnimated(): boolean {
        return this.tile.params.flags.activeDHW === 1 || this.tile.params.flags.activeHeating === 1;
    }

    setTemplate(): void {
        if (this.tile.menuId !== 0 && !this.views.isMobileView()) {
            this.goToZonesMenu();
        } else {
            this.setSubmenuElementId();
            const zonesValue: ZoneTileViewData = {
                tile: this.tile,
            }
            this.zones.selectedZone = _.cloneDeep(zonesValue);
            this.$state.go('openTherm_select', {
                selectedModuleHash: this.parameters.selectedModuleHash
            });
        }
    }

    private goToZonesMenu(): void {
        if (!this.tile.submenuElementId) {
            this.setSubmenuElementId();
        }
        this.zones.goToMenu(this.tile, this.tile.submenuElementId);
    }

    private setSubmenuElementId() {
        this.menu.getElementMenu(this.tile.menuId); // menu element for tile
        this.menu.getMenuChildElement(this.menu.elementMenu) // set menu.submenu
        if (Array.isArray(this.menu.submenu) && this.menu.submenu[0]) {
            this.tile.submenuElementId = this.menu.submenu[0].id;
        }
    }
}
